@if (audio) {
  <div class="audio-player d-flex" #audioPlayer>
    <div class="d-flex align-items-center">
      <div class="play-toggle" (click)="onPlayBtnClick()" [class.paused]="paused">
        @if (!paused) {
          <svg-icon
            src="/static/images/scenario-item/play.svg"
          ></svg-icon>
        }
        @if (paused) {
          <svg-icon
            src="/static/images/scenario-item/pause.svg"
          ></svg-icon>
        }
      </div>
      <div class="text">
        <span class="file-name"> </span
          ><span class="audio-duration" #durationEl>0:00</span>
        </div>
      </div>
      <div class="controls">
        <div class="time">
          <div class="timeline__wrapper" (click)="skipAround($event)">
            <div class="timeline">
              <div class="timeline__filled" #progressBar></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
